/* 
 * Google Address Autocomplete Plugin
 * Google Documentation URLs
 * - https://developers.google.com/maps/documentation/javascript/get-api-key
 * - https://developers.google.com/maps/documentation/javascript/places-autocomplete#address_forms
 * - https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform
 */
// Defining Google Variables in the global scopes
var placeSearch, autocomplete=[];
(function ($) {
	//googleAddressAutocomplete
	$.fn.googleAddressAutocomplete = function (options) {
		// default settings
		var settings = $.extend({
			$country: this,
			$addressLookup: $('#address-lookup'),
			$addressWrapper: $('.address-wrapper'),
			formFields: {
				$housename: $('#housename'),
				$address1: $('#address1'),
				$address2: $('#address2'),
				$address3: $('#address3'),
				$city: $('#city'),
				$cityselect: $('#cityselect'),
				$state: $('#state'),
				$stateselect: $('#stateselect'),
				$zip: $('#zip')
			},
			$skipAddressLookupBtn: $('#skip-address-lookup-btn'),
			$addressLookupBtn: $('#address-lookup-btn'),
			loadMapAPI: true,
			debug: false
		}, options);

		if (settings.debug === true) {
			console.log('options:', settings);
		}

		var countryCode = '';

		// Private closure to control how the data is populate into fields
		var addressAutocomplete = {
			/**
			 * init - when called, this (re) intializes the Google Address Autocomplete service to fetch addresses based on the country currently selected. 
			 * @param  {object} settings    - options defined in plugin
			 * @param  {string} countryCode - two character country code
			 */
			init: function (settings, countryCode) {
				if (countryCode != '' && countryCode != settings.$addressLookup.data('locale')) {
					//var input = document.getElementById('addressLookup');
					//var countryCode = document.getElementById('country').value; - delete later, countryCode should always be passed
					var options = {
						types: ['address'], // geocode vs address
						componentRestrictions: {country: countryCode} //document.getElementById('country').value
					};

					//leaving comments for the time being for testing purposes
					if (settings.debug === true) {
						console.log('google autocomplete options: ', options);
						console.log('autocomplete initiated');
					}

					var index;
					// when autocompleteIndex is undefined, this is the first time autocomplete is getting initialized.
					if (settings.$country.data('autocompleteIndex') === undefined) {
						// Find the index to set the new autocomplete item. Each item represents an instance of the autocomplete on the page
						index = autocomplete.length;
						// set the index for reference later
						settings.$country.data('autocompleteIndex',index);
						// initiate google's autocomplete and add the listner
						autocomplete[index] = new google.maps.places.Autocomplete(settings.$addressLookup[0], options);
						autocomplete[index].addListener('place_changed', function() {
							addressAutocomplete.getComponents(index);
						});	
					} else {
						// autocomplete has been initialized before on this country field
						index = settings.$country.data('autocompleteIndex');
						// clear any value in the address lookup field
						settings.$addressLookup.val('');
						// reset the country filter to the new option selected
						autocomplete[index].setComponentRestrictions({'country': countryCode});
					}

					if (settings.debug === true) {
						console.log('index in page: ', index);
						console.log('autocomplete array', autocomplete);
					}


					settings.$addressLookup.data('locale', countryCode);
				} else {
					if (settings.debug === true) {
						console.log('no need to initiate autocomplete at this time');
					}
				}
			},

			/**
			 * getComponents - when a user clicks on an address, this will capture the JSON result and:
			 * 					1. Parse the JSON result to populate our form fields on the page
			 * 					2. Trigger the function to hide the address look up field
			 * 					3. Show the address fields on the page 
			 * @param  {number} index - represents the instance that of the autocomplete that has been initialized on the page
			 */
			getComponents: function (index) {
				// clear all fields before populating the address data from google
				$.fn.googleAddressAutocomplete.clearAddressFields(settings.formFields);

				// Get the place details from the autocomplete object.
				var place = autocomplete[index].getPlace();

				//leaving comments for the time being for testing purposes
				if (settings.debug === true) {
					console.log('place: ', place);
				}

				// check for sublocality_level_4 to determine multi address lines (KR)
				var hasNeighborhood = place.address_components.some(function(component) {
					return component.types[0] === 'sublocality_level_4';
				});

				// loop the the address_component to populate the form fields on the page
				for (var i = 0; i < place.address_components.length; i++) {
					var type = place.address_components[i].types[0],
						data,
						$formField,
						separator = ' '; 
					
					// handle each address_component based on form input needs
					switch (type) {
						case 'street_number': 
						case 'premise': 
							// define vars to populate field
							data = place.address_components[i]['short_name'];
							$formField = settings.formFields.$address1;
							// populate value for field
							addressAutocomplete.populateTextField(data, $formField);
							break;
						case 'route': 
						case 'sublocality_level_4':
						case 'sublocality_level_2':
							// define vars to populate field
							var isMultiLine = hasNeighborhood && type === 'sublocality_level_2';
							data = place.address_components[i]['long_name'];
							$formField = isMultiLine ? settings.formFields.$address2 : settings.formFields.$address1;
							// populate value for field
							addressAutocomplete.populateTextField(data, $formField, separator);
							break;
						case 'neighborhood':
							// In some cases, locality / postal_town is not provided, when this happens we'll use neighborhood.
							// Before using neighborhood, test to see if locality / postal_town is in list by testing the next address_component after neighborhood.
							// Sometimes both neighborhood and locality are included in the results. When this occurs, we should use locality. 
							if (place.address_components[i + 1].types[0] === 'locality' || place.address_components[i + 1].types[0] === 'postal_town') {
								// break here to not run the scripts under locality
								break;
							} else {
								// no break, want to use the scripts under locality / postal_town to populate city
							}
						case 'locality':
						case 'postal_town':
						case 'sublocality_level_1':
							// Some locales, like the UK, the city is set to postal_town, not locality.
							// The populating of city data is the same, regardless if it's locality or postal_town
							// When both exist, only use postal_town
							if (place.address_components[i].types[0] === 'locality' && place.address_components[i + 1].types[0] === 'postal_town') {
								// when locality & postal_town is present, put locality in address 2 (at least for uk)
								// populate locality value for address 2
								if (!settings.formFields.$address2.prop('disabled')) {
									// define vars to populate field
									data = place.address_components[i]['long_name'];
									$formField = settings.formFields.$address2;
									// populate value for field
									addressAutocomplete.populateTextField(data, $formField);
								}
								break;
							} else {
								// no break, want to use the scripts under locality to populate city
							}

							// populate value for city as a text field 
							if (!settings.formFields.$city.prop('disabled')) {
								// define vars to populate field
								data = place.address_components[i]['long_name'];
								$formField = settings.formFields.$city;
								// populate value for field
								addressAutocomplete.populateTextField(data, $formField);
							}

							// populate value for city as a select field
							if (!settings.formFields.$cityselect.prop('disabled')) {
								// switch data to an objext, so that we can select an option based on short & long names
								data = {};
								// define vars to populate field
								data['short_name'] = place.address_components[i]['short_name'];
								data['long_name'] = place.address_components[i]['long_name'];
								$formField = settings.formFields.$cityselect;
								// populate value for field
								addressAutocomplete.selectOption(data, $formField);
							}
							break;
						case 'administrative_area_level_1': 
						case 'administrative_area_level_2': 
							// default is to use administrative_area_level_1 for state fields
							// when state field label is set to County, use administrative_area_level_2
							var $formFieldLabel = $('label[for="' + settings.formFields.$state.attr('id') + '"]');
							if (place.address_components[i].types[0] === 'administrative_area_level_1') {
								// this is administrative_area_level_1
								if ($formFieldLabel.text().toLowerCase().indexOf('county') > -1) {
									// state field label is set to county, break to prevent administrative_area_level_1 data from being populated
									break;
								} else {
									// no break, want to use the data from administrative_area_level_1 for state
								}
							} else {
								// this is administrative_area_level_2
								if ($formFieldLabel.text().toLowerCase().indexOf('county') === -1) {
									// state field label is not set to county, break to prevent administrative_area_level_2 data from being populated
									break;
								} else {
									// no break, want to use the data from administrative_area_level_2 for state / country
								}
							}

							// populate value for state as a text field 
							if (!settings.formFields.$state.prop('disabled')) {
								// define vars to populate field
								data = place.address_components[i]['long_name'];
								$formField = settings.formFields.$state;
								// populate value for field
								addressAutocomplete.populateTextField(data, $formField);
							}

							// populate value for state as a select field
							if (!settings.formFields.$stateselect.prop('disabled')) {
								// switch data to an objext, so that we can select an option based on short & long names
								data = {};
								// define vars to populate field
								data['short_name'] = place.address_components[i]['short_name'];
								data['long_name'] = place.address_components[i]['long_name'];
								$formField = settings.formFields.$stateselect;
								// populate value for field
								addressAutocomplete.selectOption(data, $formField);
							}
							break;
						case 'postal_code_prefix': 
						case 'postal_code':
							// define vars to populate field
							data = place.address_components[i]['short_name'];
							$formField = settings.formFields.$zip;
							// populate value for field
							addressAutocomplete.populateTextField(data, $formField);
							break;
						case 'postal_code_suffix': 
							// define vars to populate field
							data = place.address_components[i]['short_name'];
							$formField = settings.formFields.$zip;
							// populate value for field
							addressAutocomplete.populateTextField(data, $formField, '-');
							break;
					}
				}

				//show address fields & hide address lookup field - don't need this any more
				$.fn.googleAddressAutocomplete.displayAddressFields(true, settings.$addressWrapper);
				$.fn.googleAddressAutocomplete.displayLookupField(false, settings.$addressLookup);
			},

			/**
			 * populateTextField - populates text field. If field has a value already in it (like street number), a 'separator' will be added between existing content and newly added content
			 * @param  {string} data              - address content to be populated
			 * @param  {jQuery Object} $textField - jQuery element of the field on the page
			 * @param  {string} separator         - any character(s) to be used for as a separator. Default is space
			 */
			populateTextField: function (data, $textField, separator) {
				var fieldValue = $textField.val();
				// test to see if $textField has anything entered before setting data to it's value
				if (fieldValue !== '') {
					// test for separator, if one is not defined set it to be a blank space
					if (separator === undefined) {
						var separator = ' ';
					}
					// append the data to the existing fieldValue
					data = fieldValue + separator + data;
				}
				// set $textField value
				$textField.val(data);
			},

			/**
			 * selectOption - selects matching option in select menu
			 * @param  {string} data              - value or text to be matched on desired option in select menu
			 * @param  {jQuery Object} $textField - jQuery element of the field on the page
			 */
			selectOption: function (data, $selectField) {
				// find option using short_name
				var $selectOption = $selectField.find('option[value="' + data['short_name'] + '"]');
				// use long_name if short_name does not match up to anything
				if ($selectOption.length === 0) {
					// need to loop over all options to check text
					$selectField.find('option').each(function () {
						if ($(this).text() == data['long_name']) {
							$selectOption = $(this);
						}
					});
				}
				// select option
				$selectOption.prop('selected',true);
			},

			/**
			 * unbindAutocomplete - unbind the listner for the Google Autocomplete plugin when a user wants to skip
			 */
			unbindAutocomplete: function (index) {
				autocomplete[index].unbindAll();
				autocomplete[index].removeListener('place_changed');
			}
		}

		/* Event bindings to country select menu, and address lookup buttons */
		if (settings.$country !== undefined && settings.$country.length > 0) {
			// when a new country is selected, refresh Google Address Autocomplete
			settings.$country.on('change', function (e) {
				countryCode = $(this).val();
			    $.fn.googleAddressAutocomplete.displayAddressFields(false, settings.$addressWrapper);
			    if (settings.$country.data('initAutocomplete') == 'true') {
					// when initAutocomplete is true, show the address lookup field and initialize the autocomplete plugin with current country code passed as the region restriction
					if (countryCode !== '') {
						$.fn.googleAddressAutocomplete.displayLookupField(true, settings.$addressLookup);
						addressAutocomplete.init(settings, countryCode);
					}
				} else {
					$.fn.googleAddressAutocomplete.displayAddressFields(true, settings.$addressWrapper);
				}
			});

			// when onload of addressAutocomplete, initialize Google Address Autocomplete 
			settings.$country.on('addressAutocomplete.onload', function (e) {
				countryCode = $(this).val();
				dataValue = $(this).data('value');
				// only hide the address fields if we're not repopulating the values (dataValue)
			    if (dataValue === undefined || dataValue === '') {
					$.fn.googleAddressAutocomplete.displayAddressFields(false, settings.$addressWrapper);
					$.fn.googleAddressAutocomplete.displayLookupField(true, settings.$addressLookup);
				} else {
					$.fn.googleAddressAutocomplete.displayAddressFields(true, settings.$addressWrapper);
				}
				// inializing Google Address Autocomplete 
				addressAutocomplete.init(settings, countryCode);
				// display the address lookup button after addressAutocomplete has loaded to prevent any flicker of button
				settings.$addressLookupBtn.removeClass('hidden');
			});
		} else {
			if (settings.debug === true) {
				console.log('settings.$country is ', settings.$country);
				if (settings.$skipAddressLookupBtn !== undefined) {
					console.log('settings.$country.length ', settings.$country.length);
				}
			}
		}

		// skip address lookup
		if (settings.$skipAddressLookupBtn !== undefined && settings.$skipAddressLookupBtn.length > 0) {
			settings.$skipAddressLookupBtn.on('click', function () {
				settings.$country.data('initAutocomplete',false);
				$.fn.googleAddressAutocomplete.displayAddressFields(true, settings.$addressWrapper);
				$.fn.googleAddressAutocomplete.displayLookupField(false, settings.$addressLookup);
			});
		} else {
			if (settings.debug === true) {
				console.log('settings.$skipAddressLookupBtn is ', settings.$skipAddressLookupBtn);
				if (settings.$skipAddressLookupBtn !== undefined) {
					console.log('settings.$skipAddressLookupBtn.length ', settings.$skipAddressLookupBtn.length);
				}
			}
		}

		// return to address lookup
		if (settings.$addressLookupBtn !== undefined && settings.$addressLookupBtn.length > 0) {
			settings.$addressLookupBtn.on('click', function () {
				settings.$country.data('initAutocomplete',true);
				$.fn.googleAddressAutocomplete.displayAddressFields(false, settings.$addressWrapper);
				$.fn.googleAddressAutocomplete.displayLookupField(true, settings.$addressLookup);
				$.fn.googleAddressAutocomplete.clearAddressFields(settings.formFields);
			});
		} else {
			if (settings.debug === true) {
				console.log('settings.$addressLookupBtn is ', settings.$addressLookupBtn);
				if (settings.$addressLookupBtn !== undefined) {
					console.log('settings.$addressLookupBtn.length ', settings.$addressLookupBtn.length);
				}
			}
		}

		// load maps API (as needed) and initialize autocomplete for current country
		if (typeof loadJS === 'function') {
			// load the maps api as needed
			if (settings.loadMapAPI === true) {
				loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBwbSWKna_K2NGeAjGMKhWhNQ-m9bfCl2E&libraries=places',function () {
					// set initAutocomplete to true once the plugin file has loaded
					settings.$country.data('initAutocomplete','true').trigger('addressAutocomplete.onload');
				});
			} else {
				// use a set interval to make sure the api is loaded, if not, wait
				// doing this to allow for multiple forms to be initialized at once on document ready
				var googleMapsApiCheck = setInterval(function() {
					if (typeof google === 'object' && typeof google.maps ==='object') {
						clearInterval(googleMapsApiCheck);
						settings.$country.data('initAutocomplete','true').trigger('addressAutocomplete.onload');
					}
				},50);
			}
		} else {
			if (settings.debug === true) {
				console.error('Help function loadJS is not on the page.');
			}
		}

		// return element for chainability
		return this;

	}// end $.fn.googleAddressAutocomplete

	/**
	 * displayLookupField - public function to toggle the display of the address lookup field
	 * @param  {Boolean} isVisible        - defines if field should be visible or not
	 * @param  {jQuery Object} $textField - jQuery element of the field on the page
	 */
	$.fn.googleAddressAutocomplete.displayLookupField = function (isVisible, $addressLookup) {
		if (isVisible) {
			$addressLookup.closest('.address-lookup-row').removeClass('hidden');
		} else {
			$addressLookup.val('').closest('.address-lookup-row').addClass('hidden');
		}
	}

	/**
	 * displayAddressFields - public function to toggle the display of the container that holds the address fields on the page
	 * @param  {Boolean} isVisible        - defines if field should be visible or not
	 * @param  {jQuery Object} $textField - jQuery element of the field on the page
	 */
	$.fn.googleAddressAutocomplete.displayAddressFields = function (isVisible, $addressWrapper) {
		if (isVisible) {
			$addressWrapper.removeClass('hidden');
		} else {
			$addressWrapper.addClass('hidden');
		}
	}

	/**
	 * displayAddressFields - public function to clear the value of the address fields
	 * @param  {[type]}  formFields - list of jQuery objects for the form fields on  the page
	 */
	$.fn.googleAddressAutocomplete.clearAddressFields = function (formFields) {
		for (var field in formFields) {
			formFields[field].val('');
		}
	}			

})(jQuery);